import { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../@types/RootState';
import { selectorUser } from '../../lib/selectorUser';
import { setClickToLocalStorage } from '../../utils/setClickToLocalStorage';
import { ModalIPALead } from '../ModalIPALead';
import { ModalMPDVLead } from '../ModalMPDVLead';
import ModalNoAccessInfoPanel from '../ModalNoAccessInfoPanel';
import NoAssociationModal from '../NoAssociationModal';
import styles from './NavBar.module.scss';
import NavBarActions from './NavBarActions/NavBarActions';
import NavBarContent from './NavBarContent/NavBarContent';
import NavBarMenu from './NavBarMenu/NavBarMenu';

type NavBarProps = ReturnType<typeof mapStateToProps>;

const NavBar = ({ user }: NavBarProps) => {
  const setListenerZendeskButton = useCallback(() => {
    const element = document.getElementById('launcher-frame') as HTMLIFrameElement | null;

    if (!element || !element.contentWindow) return;

    element.contentWindow.document.body.querySelector('[data-testid="launcher-wrapper"]')?.addEventListener('mouseup', () => {
      setClickToLocalStorage('atendimento', 'atendimento', user);
    });
  }, [user]);

  useEffect(() => {
    setTimeout(() => {
      setListenerZendeskButton();
    }, 4000);
  }, [setListenerZendeskButton]);

  return (
    <>
      <nav className={styles['nav-bar']}>
        <NavBarMenu />
        <NavBarContent />
        <NavBarActions />
      </nav>
      <ModalNoAccessInfoPanel />
      <ModalMPDVLead />
      <ModalIPALead />
      <NoAssociationModal />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: selectorUser(state),
});

export default connect(mapStateToProps)(NavBar);
